import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { SafeHtmlModule } from "app/shared/pipes/safe-html/safe-html.module";
import { GenericNotificationComponent } from "./generic-notification.component";

@NgModule({
    declarations: [GenericNotificationComponent],
    exports: [GenericNotificationComponent],
    imports: [CommonModule, MatDialogModule, FlexModule, MatIconModule, MatButtonModule, SafeHtmlModule]
})
export class GenericNotificationModule {}

